var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.825 8C15.6062 8 15.3964 8.08692 15.2416 8.24164C15.0869 8.39635 15 8.6062 15 8.825C15 9.0438 15.0869 9.25365 15.2416 9.40836C15.3964 9.56308 15.6062 9.65 15.825 9.65H18.575C18.7938 9.65 19.0036 9.56308 19.1584 9.40836C19.3131 9.25365 19.4 9.0438 19.4 8.825C19.4 8.6062 19.3131 8.39635 19.1584 8.24164C19.0036 8.08692 18.7938 8 18.575 8H15.825Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.025 0C2.22272 0 1.4533 0.318704 0.886002 0.886002C0.318705 1.4533 0 2.22272 0 3.025V12.375C0 13.1773 0.318705 13.9467 0.886002 14.514C1.4533 15.0813 2.22272 15.4 3.025 15.4H18.975C19.7773 15.4 20.5467 15.0813 21.114 14.514C21.6813 13.9467 22 13.1773 22 12.375V3.025C22 2.22272 21.6813 1.4533 21.114 0.886002C20.5467 0.318704 19.7773 0 18.975 0H3.025ZM1.65 12.375V6.6H20.35V12.375C20.35 13.134 19.734 13.75 18.975 13.75H3.025C2.266 13.75 1.65 13.134 1.65 12.375ZM1.65 4.95V3.025C1.65 2.266 2.266 1.65 3.025 1.65H18.975C19.734 1.65 20.35 2.266 20.35 3.025V4.95H1.65Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ee9071d5cfe5b06bea2feee72bd140a0.svg";
export { ForwardRef as ReactComponent };